export var FocusActionType;
(function (FocusActionType) {
    FocusActionType["addFocusElement"] = "ADD_FOCUS_ELEM";
    FocusActionType["removeFocusElement"] = "REMOVE_FOCUS_ELEM";
    FocusActionType["focusFirstElement"] = "FOCUS_FIRST_ELEMENT";
})(FocusActionType || (FocusActionType = {}));
export const focusReducer = (state, action) => {
    switch (action.type) {
        case FocusActionType.addFocusElement:
            return [
                ...state,
                {
                    element: action.element,
                },
            ];
        case FocusActionType.removeFocusElement:
            const focusElementsCopy = [...state];
            const elementToFocus = focusElementsCopy[focusElementsCopy.length - 1];
            if (!!elementToFocus.element) {
                window.setTimeout(() => {
                    elementToFocus.element.focus();
                }, 10);
            }
            focusElementsCopy.pop();
            return focusElementsCopy;
        case FocusActionType.focusFirstElement:
            if (!!state[0].element) {
                window.setTimeout(() => {
                    state[0].element.focus();
                }, 10);
            }
            return [];
        default:
            return state;
    }
};
//# sourceMappingURL=focusReducer.js.map